<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ userData.user_fullname.charAt(0).toUpperCase() + userData.user_fullname.slice(1) }}
        </p>
        <span class="user-status">{{ userData.UserRoleName }}</span>
      </div>
      <b-avatar
        size="40"
        :src="userData.avatar"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          v-if="!userData.user_fullname.charAt(0).toUpperCase() + userData.user_fullname.slice(1)"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      :to="{ path: '/apps/users/profile' }"
    >
      <span>Profile</span>
    </b-dropdown-item>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <span>Logout</span>
    </b-dropdown-item></b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BAvatar,
} from 'bootstrap-vue'
import { getUserData } from '@/auth/utils'
import { avatarText } from '@core/utils/filter'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BAvatar,
  },
  data() {
    return {
      userData: getUserData(),
      avatarText,
    }
  },
  methods: {
    logout() {
      // Remove userData from sessionStorage
      // ? You just removed token from sessionStorage. If you like, you can also make API call to backend to blacklist used token
      // Remove everythings from sessionStorage
      // Remove 'userToken' cookie
      this.$cookies.remove('userToken')

      // Remove 'userData' cookie
      this.$cookies.remove('userData')

      // Remove 'userBranch' cookie
      this.$cookies.remove('userBranch')

      // Remove 'userPermissions' cookie
      this.$cookies.remove('userPermissions')

      this.$router.push({ name: 'auth-login' })
    },
  },
}
</script>
